import BaseAttribute, { AttributeExport, AttributeExportTypes } from './baseAttribute';
import DiceAttribute, { DiceAttributeExport } from './diceAttribute';
import { ValueExport } from './valueAttribute';
import Resource from './resource';
import ElementAttribute, { ElementExport } from './element';
import Talent, { TalentExport } from './talent';
import { TalentField } from '../character/allValues';

export class AttributeFactory {
  public static import(data: AttributeExport): BaseAttribute {
    switch (data.type) {
      case AttributeExportTypes.Dice:
        const diceData = data as DiceAttributeExport;
        const diceAttribute = new DiceAttribute(diceData.name);
        diceAttribute.numDice = diceData.dice;
        diceAttribute.numBonus = diceData.modifier;
        return diceAttribute;

      case AttributeExportTypes.Element:
        const elementData = data as ElementExport;
        const elementAttribute = new ElementAttribute(elementData.name, elementData.isProtection);
        elementAttribute.numDice = elementData.dice;
        elementAttribute.numBonus = elementData.modifier;
        return elementAttribute;

      case AttributeExportTypes.Resource:
        const resourceData = data as ValueExport;
        const resourceAttribute = new Resource(resourceData.name);
        resourceAttribute.value = resourceData.value;
        return resourceAttribute;

      case AttributeExportTypes.Talent:
        const talentData = data as TalentExport;
        const talentAttribute = new Talent(talentData.name, talentData.field as TalentField);
        talentAttribute.value = talentData.value;
        return talentAttribute;
      default:
        throw new Error('Cannot import attribute of type: ' + data.type);
    }
  }
}
